import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { QueryParamsHandling, RouterModule } from '@angular/router';
import { Observable, Subject, take, takeUntil } from 'rxjs';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

@Component({
  selector: 'ish-product-name',
  templateUrl: './product-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule],
})
export class ProductNameComponent implements OnInit, OnDestroy {
  private context = inject(ProductContextFacade);
  private gtmFacade = inject(GoogleTagManagerFacade);
  private queryParamsHandlingInjector = inject<QueryParamsHandling>('PRODUCT_QUERY_PARAMS_HANDLING' as any, {
    optional: true,
  })!;

  readonly link = input(true);
  readonly alternate = input<string>(undefined);
  readonly queryParamsHandling = input<QueryParamsHandling>('');

  productName$: Observable<string>;
  productURL$: Observable<string>;
  visible$: Observable<boolean>;
  private destroy$ = new Subject<void>();
  computedQueryParamsHandling: QueryParamsHandling;
  product: ProductView;

  ngOnInit() {
    this.productName$ = this.context.select('product', 'name');
    this.productURL$ = this.context.select('productURL');
    this.visible$ = this.context.select('displayProperties', 'name');
    this.computedQueryParamsHandling = this.queryParamsHandlingInjector ?? this.queryParamsHandling();
  }

  viewItemGTMEvent() {
    this.context
      .select('product')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(product => {
        this.product = product;
        const products: ProductView[] = [this.product];
        this.gtmFacade.triggerGTMEvent('view_item', products);
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
